import { render, staticRenderFns } from "./life-experience-pavilion.vue?vue&type=template&id=50b1e3aa&"
import script from "./life-experience-pavilion.vue?vue&type=script&lang=js&"
export * from "./life-experience-pavilion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports